import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
// import logo from "../assets/img/odina2.png";
import github from '../assets/img/github.png';
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            {/* <img src={logo} alt="Logo" /> */}
          </Col>
          <Col size={12} sm={12} className="text-center text-sm-center">
            <div className="social-icon">
              <a href="https://github.com/adamdalechurch/" target="_blank"><img src={github} alt="" /></a>
            </div>
            <p>Adam D. Church, Web Developer</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
